import { makeStyles } from '@material-ui/core/styles'
import Lottie from 'lottie-react'
import loadingJSON from './loading.json'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff80',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
    },

    divCenterScreen: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        // marginTop: '-125px', //โลมา
        // marginLeft: '-125px', //โลมา
        marginTop: '-65px',
        marginLeft: '-175px',
    },
}))

type MyLoadingProps = {
    isShowLoading?: boolean
    // rootStyle?: any
}
const MyLoading = ({ isShowLoading = true }: MyLoadingProps) => {
    const classes = useStyles()

    return (
        <div
            className={classes.root}
            style={{
                display: isShowLoading ? 'block' : 'none',
            }}
        >
            <div className={classes.divCenterScreen}>
                <Lottie
                    animationData={loadingJSON}
                    renderer="svg"
                    loop
                    autoplay
                    // style={{ width: '250px', height: '250px' }} //โลมา
                    style={{ width: '350px', height: '130px' }}
                />
            </div>
        </div>
    )
}

export default MyLoading
